interface CircularProgressBarProps {
  strokeWidth?: number;
  sqSize?: number;
  percentage: number;
}

const CircularProgressBar: React.FC<CircularProgressBarProps> = ({
  strokeWidth = 5,
  sqSize = 100,
  percentage
}) => {
  // SVG centers the stroke width on the radius, subtract out so circle fits in square
  const radius = (sqSize - strokeWidth) / 2;
  // Enclose cicle in a circumscribing square
  const viewBox = `0 0 ${sqSize} ${sqSize}`;
  // Arc length at 100% coverage is the circle circumference
  const dashArray = radius * Math.PI * 2;
  // Scale 100% coverage overlay with the actual percent
  let dashOffset = dashArray - dashArray * (percentage / 100);
  if (isNaN(dashOffset)) {
    dashOffset = dashArray;
  }

  return (
    <svg width={sqSize} height={sqSize} viewBox={viewBox}>
      <circle
        className="fill-transparent stroke-primary-80"
        cx={sqSize / 2}
        cy={sqSize / 2}
        r={radius}
        strokeWidth={`${strokeWidth}px`}
      />
      <circle
        className="fill-transparent round-stroke stroke-primary-50"
        cx={sqSize / 2}
        cy={sqSize / 2}
        r={radius}
        strokeWidth={`${strokeWidth}px`}
        // Start progress marker at 12 O'Clock
        transform={`rotate(-90 ${sqSize / 2} ${sqSize / 2})`}
        strokeDashoffset={dashOffset}
        strokeDasharray={dashArray}
      />
    </svg>
  );
};

export default CircularProgressBar;
